// @flow
import React, { useRef } from 'react';
import BrandTypography from '@justpark/ui/src/components/BrandTypography';
import Typography from '@justpark/ui/src/components/Typography';
import Button from '@justpark/ui/src/components/Button';
import ImageResizer from '../../components/Common/ImageResizer';
import SearchFormModule from './SearchFormModule';
import useLandingData from './useLandingData';
import CmsContent from '../../components/CmsContent';

import styles from './landingHero.module.scss';

const heroImage = [
  {
    width: 2 * 320,
    height: 2 * 225,
    breakpointMaxWidth: 374
  },
  {
    width: 2 * 375,
    height: 2 * 265,
    breakpointMaxWidth: 381
  },
  {
    width: 2 * 390,
    height: 2 * 442,
    breakpointMaxWidth: 424
  },
  {
    width: 2 * 647,
    height: 2 * 625,
    breakpointMaxWidth: 859
  },
  {
    width: 2 * 540,
    height: 2 * 540,
    breakpointMaxWidth: 1023
  },
  {
    width: 2 * 625,
    height: 2 * 625
  }
];

const LandingHero = () => {
  const landingData = useLandingData();

  const searchFormRef = useRef(null);
  const searchInputRef = useRef(null);
  const onFindClick = () => {
    searchFormRef.current.scrollIntoView();
    searchInputRef.current.focus();
  };

  const bookingCount = new Intl.NumberFormat('en-GB').format(
    landingData.numberOfBooked
  );

  return (
    <div className={styles.landingHero}>
      <div className={styles.contentImageWrapper}>
        <div className={styles.imageContainer}>
          <ImageResizer
            imageKey={landingData.heroImageUrl}
            images={heroImage}
            className={styles.image}
            isLCP
          />
        </div>
        <div className={styles.contentContainer}>
          <div className={styles.contentWrapper}>
            <div className={styles.content}>
              <BrandTypography level={1} className={styles.heroHeading} bold>
                <CmsContent content={landingData.title} />
              </BrandTypography>
              <Typography className={styles.heroSubtext} bold>
                <p>{landingData.description}</p>
              </Typography>
              <Typography>
                <p>{landingData.body}</p>
              </Typography>

              <Typography bold>
                <p className={styles.bookingCount}>
                  {bookingCount} people JustParked this week
                </p>
              </Typography>

              <Button
                onClick={onFindClick}
                className={styles.findParkingButton}
              >
                Find parking
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.searchForm} ref={searchFormRef}>
        <BrandTypography level={3} className={styles.searchFormHeading} bold>
          Access 10,000+ spaces
        </BrandTypography>
        <SearchFormModule
          searchInputRef={searchInputRef}
          defaultLocation={landingData.centerPoint}
        />
      </div>
    </div>
  );
};

export default LandingHero;
